import styled from 'styled-components';

import { Box } from 'components/Box';
import { PrimaryButtonRouterLink } from 'components/Button';
import { LegacyTertiaryButton } from 'components/Button/LegacyTertiaryButton';
import { Meter } from 'components/Meter';
import ResumeDatabaseResponseContainer from 'containers/ResumeDatabaseResponseContainer';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { colors, fontWeights } from 'theme/theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';

const StyledLinkButton = styled(LegacyTertiaryButton)`
  color: ${colors.lightContentGrey};
  font-size: inherit;
  font-weight: ${fontWeights.normal};
  text-decoration: underline;
`;

type Props = {
  closeMenu: () => void;
};

export function PageHeaderAccountDropdownProfileSection({ closeMenu }: Props) {
  const { user } = useUserEnvironment();
  return (
    <Box
      minWidth={200}
      px={12}
      pt={16}
      pb={24}
      textAlign="center"
      borderBottom={`1px solid ${colors.selectionGrey}`}
    >
      <Box mb="8px" color={colors.lightContentGrey}>
        {getText('Your profile is incomplete')}
      </Box>
      <Meter
        current={1}
        total={3}
        color="brandGreen"
        delay={0}
        duration={0.5}
      />
      <Box mt={20} mb="8px">
        <PrimaryButtonRouterLink
          to="/dashboard/employment-profile/get-discovered"
          size="small"
          onClick={() => {
            closeMenu();
            trackClicked('Add Resume', {
              context: 'Header User Dropdown',
            });
          }}
        >
          {user?.resumeId ? getText('Share Resume') : getText('Add Resume')}
        </PrimaryButtonRouterLink>
      </Box>
      <Box width={1} display="flex" flexDirection="column" alignItems="center">
        <ResumeDatabaseResponseContainer>
          {({ dismiss }) => (
            <StyledLinkButton
              onClick={(e) => {
                e.preventDefault();
                dismiss();
                trackClicked('Dismiss Resume Database CTA', {
                  context: 'Header User Dropdown',
                });
              }}
            >
              {getText('No, thanks')}
            </StyledLinkButton>
          )}
        </ResumeDatabaseResponseContainer>
      </Box>
    </Box>
  );
}
